import axios from 'axios';
import type { AxiosRequestConfig } from 'axios';
import ChatBIInterceptor from './interceptors/ChatBIInterceptor';
import BaspInterceptor from './interceptors/BaspInterceptor';
import DefaultInterceptor from './interceptors/DefaultInterceptor';
import LoginInterceptor from './interceptors/LoginInterceptor';
import type { HttpResponse } from './types';
import useSettingsStore from '../stores/modules/settings';
import { isProduction } from '../utils/env';

const axiosInstance = axios.create({
  timeout: 1000 * 60,
  responseType: 'json',
});

// 请求拦截器
axiosInstance.interceptors.request.use((config) => {
  const { settings } = useSettingsStore();
  if (settings.api.baseURL) {
    config.baseURL = settings.api.baseURL;
  }
  return config;
});
axiosInstance.interceptors.request.use(...ChatBIInterceptor.request);
axiosInstance.interceptors.request.use(...BaspInterceptor.request);
axiosInstance.interceptors.request.use(...LoginInterceptor.request);
axiosInstance.interceptors.request.use(...DefaultInterceptor.request);

// 响应拦截器
axiosInstance.interceptors.response.use(...ChatBIInterceptor.response);
axiosInstance.interceptors.response.use(...BaspInterceptor.response);
axiosInstance.interceptors.response.use(...LoginInterceptor.response);
axiosInstance.interceptors.response.use(...DefaultInterceptor.response);

// 封装axios请求，充分利用类型检查与提示
const request = async <T = any>(config: AxiosRequestConfig): Promise<HttpResponse<T>> => {
  const { data } = await axiosInstance.request<HttpResponse<T>>(config);
  return data;
};

/**
 * 获取签名请求头
 */
const getSignHeaders = async () => {
  const { default: MD5 } = await import('crypto-js/md5');
  const appKey = !isProduction ? '674ad2007e6e69adc6fc12d93d1cb741' : '832c1d1d2b6d00ddeec8bc22be26b327';
  const appSecret = !isProduction ? '335fa5e50b7a989d2c3cd12443d63ef7' : '898fc8c88e974d41668c2afce7e0d844';
  const timestamp = new Date().getTime();
  const sign = MD5(`${timestamp}${appKey}${appSecret}`).toString()

  return { appKey, timestamp, sign }
}

export { request, axiosInstance, getSignHeaders };
